import type { Action } from 'svelte/action';
import type { ButtonColor } from '@athena-lib/Button';
import { Type, type Static } from '@sinclair/typebox';

export const TrustPilotApiResponseSchema = Type.Object({
  reviews: Type.Array(
    Type.Object({
      content: Type.String(),
      createdAt: Type.String(),
      stars: Type.Number(),
      displayName: Type.String(),
      qualityRating: Type.Optional(Type.Number()),
      valueForMoneyRating: Type.Optional(Type.Number()),
    }),
  ),
  starsAverage: Type.Number(),
  allReviews: Type.Number(),
  tpLogo: Type.String(),
  reviewsUrl: Type.Optional(Type.String()),
  starsString: Type.String(),
});

export type TrustpilotApiResponse = Static<typeof TrustPilotApiResponseSchema>;

export type TrustPilotProductReviewListProps = {
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
  apiResponse: TrustpilotApiResponse;
  heading?: string;
  sku?: string;
  loadMoreButtonColor?: ButtonColor;
  fetchProductReviews: (params: {
    page: string;
    sku?: string;
    isoCountryCode: string;
  }) => Promise<TrustpilotApiResponse | undefined>;
};
